// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../assets/css/tabs.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#net-returns-body[data-v-eaf0c2b8] {
  margin-bottom: 35px;
}
#net-returns-body h4[data-v-eaf0c2b8] {
  font-size: 14px;
  font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
  font-weight: 400;
}
#net-returns-body .net-returns-tab-nav[data-v-eaf0c2b8] {
  border-top: 1px solid #d4d4d4;
  margin-bottom: -10px;
  display: flex;
  margin-right: 5px;
}
#net-returns-body .net-returns-tab-nav .disclosure-link[data-v-eaf0c2b8] {
  font-size: 14px;
  font-weight: 700;
}
#net-returns-body .as-of[data-v-eaf0c2b8] {
  font-family: 'AvenirNextLTW01-Regular', Arial;
  font-size: 14px;
}
#net-returns-body .annual-link[data-v-eaf0c2b8] {
  color: #1d5799;
  display: block;
  font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
  font-size: 14px;
  margin-top: 10px;
  margin-left: auto;
  margin-bottom: 30px;
  text-transform: uppercase;
}
#net-returns-body .annual-link .arrow-wrapper[data-v-eaf0c2b8] {
  display: inline-block;
  color: #878a96;
}
#net-returns-body .annual-link .arrow-wrapper .icon[data-v-eaf0c2b8] {
  line-height: 15px;
}
#net-returns-body .annual-link.large[data-v-eaf0c2b8] {
  float: right;
}
#net-returns-body .chart-legend[data-v-eaf0c2b8] {
  display: inline-block;
  margin-top: 15px;
}
#net-returns-body .chart-legend span[data-v-eaf0c2b8] {
  font-size: 12px;
  color: #666;
  font-family: 'AvenirNextLTW01-Regular', Arial;
}
#net-returns-body .chart-legend span[data-v-eaf0c2b8]:not(last-of-type) {
  margin-right: 15px;
}
#net-returns-body .net-returns-chart[data-v-eaf0c2b8] {
  margin-top: 5px;
}
#net-returns-body .net-returns-chart img[data-v-eaf0c2b8] {
  width: 100%;
}
@media (max-width: 768px) {
#net-returns-body .legend-item[data-v-eaf0c2b8] {
    display: block;
    margin: 0;
}
#net-returns-body .menu[data-v-eaf0c2b8] {
    margin-top: 20px;
}
}
@media (max-width: 480px) {
#net-returns-body .as-of[data-v-eaf0c2b8] {
    display: block;
    margin-left: 16px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/gross-net-index-returns/GrossNetIndexReturns.vue","webpack://./GrossNetIndexReturns.vue"],"names":[],"mappings":"AAEA;EACC,mBAAA;ACAD;ADDA;EAGE,eAAA;EACA,yDAAA;EACA,gBAAA;ACCF;ADNA;EAQE,6BAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;ACCF;ADZA;EAaG,eAAA;EACA,gBAAA;ACEH;ADhBA;EAkBE,6CAAA;EACA,eAAA;ACCF;ADpBA;EAsBE,cAAA;EACA,cAAA;EACA,yDAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;ACCF;AD9BA;EA+BG,qBAAA;EACA,cAAA;ACEH;ADlCA;EAkCI,iBAAA;ACGJ;ADAE;EACC,YAAA;ACEH;ADxCA;EA0CE,qBAAA;EACA,gBAAA;ACCF;AD5CA;EA6CG,eAAA;EACA,WAAA;EACA,6CAAA;ACEH;ADDG;EACC,kBAAA;ACGJ;ADpDA;EAsDE,eAAA;ACCF;ADvDA;EAwDG,WAAA;ACEH;ADCC;AAAA;IAEE,cAAA;IACA,SAAA;ACCD;ADJD;IAME,gBAAA;ACCD;AACF;ADCC;AAAA;IAEE,cAAA;IACA,iBAAA;ACCD;AACF","sourcesContent":["\n@import '~_css_/tabs.css';\n#net-returns-body {\n\tmargin-bottom: 35px;\n\th4 {\n\t\tfont-size: 14px;\n\t\tfont-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;\n\t\tfont-weight: 400;\n\t}\n\t.net-returns-tab-nav {\n\t\tborder-top: 1px solid rgb(212, 212, 212);\n\t\tmargin-bottom: -10px;\n\t\tdisplay: flex;\n\t\tmargin-right: 5px;\n\t\t.disclosure-link {\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\t.as-of {\n\t\tfont-family: 'AvenirNextLTW01-Regular', Arial;\n\t\tfont-size: 14px;\n\t}\n\t.annual-link {\n\t\tcolor: #1d5799;\n\t\tdisplay: block;\n\t\tfont-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;\n\t\tfont-size: 14px;\n\t\tmargin-top: 10px;\n\t\tmargin-left: auto;\n\t\tmargin-bottom: 30px;\n\t\ttext-transform: uppercase;\n\t\t.arrow-wrapper {\n\t\t\tdisplay: inline-block;\n\t\t\tcolor: #878a96;\n\t\t\t.icon {\n\t\t\t\tline-height: 15px;\n\t\t\t}\n\t\t}\n\t\t&.large {\n\t\t\tfloat: right;\n\t\t}\n\t}\n\t.chart-legend {\n\t\tdisplay: inline-block;\n\t\tmargin-top: 15px;\n\t\tspan {\n\t\t\tfont-size: 12px;\n\t\t\tcolor: #666;\n\t\t\tfont-family: 'AvenirNextLTW01-Regular', Arial;\n\t\t\t&:not(last-of-type) {\n\t\t\t\tmargin-right: 15px;\n\t\t\t}\n\t\t}\n\t}\n\t.net-returns-chart {\n\t\tmargin-top: 5px;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t@media (max-width: 768px) {\n\t\t.legend-item {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0;\n\t\t}\n\t\t.menu {\n\t\t\tmargin-top: 20px;\n\t\t}\n\t}\n\t@media (max-width: 480px) {\n\t\t.as-of {\n\t\t\tdisplay: block;\n\t\t\tmargin-left: 16px;\n\t\t}\n\t}\n}\n","@import '~_css_/tabs.css';\n#net-returns-body {\n  margin-bottom: 35px;\n}\n#net-returns-body h4 {\n  font-size: 14px;\n  font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;\n  font-weight: 400;\n}\n#net-returns-body .net-returns-tab-nav {\n  border-top: 1px solid #d4d4d4;\n  margin-bottom: -10px;\n  display: flex;\n  margin-right: 5px;\n}\n#net-returns-body .net-returns-tab-nav .disclosure-link {\n  font-size: 14px;\n  font-weight: 700;\n}\n#net-returns-body .as-of {\n  font-family: 'AvenirNextLTW01-Regular', Arial;\n  font-size: 14px;\n}\n#net-returns-body .annual-link {\n  color: #1d5799;\n  display: block;\n  font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;\n  font-size: 14px;\n  margin-top: 10px;\n  margin-left: auto;\n  margin-bottom: 30px;\n  text-transform: uppercase;\n}\n#net-returns-body .annual-link .arrow-wrapper {\n  display: inline-block;\n  color: #878a96;\n}\n#net-returns-body .annual-link .arrow-wrapper .icon {\n  line-height: 15px;\n}\n#net-returns-body .annual-link.large {\n  float: right;\n}\n#net-returns-body .chart-legend {\n  display: inline-block;\n  margin-top: 15px;\n}\n#net-returns-body .chart-legend span {\n  font-size: 12px;\n  color: #666;\n  font-family: 'AvenirNextLTW01-Regular', Arial;\n}\n#net-returns-body .chart-legend span:not(last-of-type) {\n  margin-right: 15px;\n}\n#net-returns-body .net-returns-chart {\n  margin-top: 5px;\n}\n#net-returns-body .net-returns-chart img {\n  width: 100%;\n}\n@media (max-width: 768px) {\n  #net-returns-body .legend-item {\n    display: block;\n    margin: 0;\n  }\n  #net-returns-body .menu {\n    margin-top: 20px;\n  }\n}\n@media (max-width: 480px) {\n  #net-returns-body .as-of {\n    display: block;\n    margin-left: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
